import React, { useState, useEffect, useMemo, memo } from 'react';

interface SingleHeadlineDisplayProps {
  imageSrc: string;
  isActive: boolean;
}

const SingleHeadlineDisplay: React.FC<SingleHeadlineDisplayProps> = ({ imageSrc, isActive }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // A small delay on activation allows for a smooth cross-fade
    let timer: NodeJS.Timeout;
    if (isActive) {
      timer = setTimeout(() => setIsVisible(true), 50);
    } else {
      setIsVisible(false);
    }
    return () => clearTimeout(timer);
  }, [isActive]);

  const containerStyle: React.CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'opacity 0.8s ease-in-out',
    opacity: isVisible ? 1 : 0,
    pointerEvents: 'none',
    zIndex: 14, // Below features, but above the cloud
  };

  const imageStyle: React.CSSProperties = {
    width: '90vw',
    maxWidth: '750px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0px 6px 20px rgba(0,0,0,0.12)',
  };

  return (
    <div style={containerStyle}>
      <img src={imageSrc} alt="Headline" style={imageStyle} />
    </div>
  );
};

export default memo(SingleHeadlineDisplay);